export default class DateTimeFiltersViewModel {
    preset: string = 'Today';
    dayOfWeek: string = '';
    startDate: Date = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    endDate: Date = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    flagTimeRange: boolean = false;
    startTime?: string = undefined;
    endTime?: string = undefined;
}